import styled from 'styled-components';
import styledProps from './styledProps';
import { displays } from './styles.js';
import { colors, fonts, textSizes, fontWeights } from '../../tailwind';
import { Text as Base } from 'rebass';
import safeProps, { strippedProps } from '../safeProps';
import React from 'react';
import _ from 'lodash';

const defaultProps = {
  color: 'grayDark',
  fontSize: 'paragraph',
  fontFamily: 'text',
  fontWeight: 'light',
  textAlign: 'left',
};

const Text = styled(props => {
  const sp = safeProps(props);
  const rest = strippedProps(sp);
  return <Base {...rest} />;
})`
  color: ${styledProps(colors, 'color')};
  font-size: ${styledProps(textSizes, 'fontSize')};
  font-family: ${styledProps(fonts, 'fontFamily')};
  font-weight: ${styledProps(fontWeights, 'fontWeight')};
  font-style: ${props => (props.italic ? 'italic' : 'normal')}
  letter-spacing: ${props =>
    props.letterSpacing ? props.letterSpacing : '0px'};
  display: ${styledProps(displays)};
  opacity: ${props => (props.primaryFaded ? '.5' : '1')};
  text-overflow: ${props => (props.noclip ? 'initial' : 'ellipsis')};
  white-space: ${props => (props.noclip ? '' : 'nowrap')};
  max-width: ${props => addRightMargin(props.maxWidth)};
  overflow: ${props => (props.overflow ? 'visible' : 'hidden')};
  cursor: ${props => (props.clickable || props.link ? 'pointer' : 'auto')}
  line-height: ${p => p.lineSpacing || null}
  textAlign: ${p => p.align || defaultProps.textAlign}

  &:hover {
    color: ${props => (props.hoverColor ? colors[props.hoverColor] : null)}
  }
`;

Text.defaultProps = defaultProps;

export default Text;

function addRightMargin(widthAsStr) {
  if (!widthAsStr || widthAsStr.length < 3) return;

  const numAsStr = widthAsStr.substring(0, widthAsStr.length - 2);
  const num = +numAsStr;
  const newWidth = num - 16;
  return newWidth + 'px';
}



// WEBPACK FOOTER //
// ./src/components_new/common/Text.js